import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import Media from "react-media";
import { useLocation, useNavigate } from "react-router-dom";
import ReactSVG from "react-svg";
import { useAuth, useCreateUserAddress, useUpdateUserAddress } from "@saleor/sdk";
import { ChangeAmountProductsContext } from "@temp/contexts";
import { commonMessages, checkoutMessages } from "@temp/intl";
import { AlertNeighborhoodOtherTrade, MainMenu } from "@temp/components";
import { FormFooter } from "@components/molecules";
import { Loader } from "@components/atoms";
import { xMediumScreen } from "@styles/constants";
import { AlertNeigDoesNotMatchOrWithoutCoverage } from "../../../components/AlertNeigDoesNotMatchOrWithoutCoverage";
import { AddressForm } from "../../components/organisms/AddressForm";
import * as S from "./styles";

var goBackImg = require("../../../images/arrowBack.svg");

var getSubmitBtnProps = function getSubmitBtnProps(text, submitButtonTestingContext, action) {
  return {
    submitBtn: action ? {
      action: action,
      testingContext: submitButtonTestingContext,
      text: text
    } : {
      testingContext: submitButtonTestingContext,
      text: text
    }
  };
};

var submitButtonTestingContext = "submitAddressFormModalButton";
var formId = "address-form";
export var AddressFormPage = function AddressFormPage() {
  var _user$currentTrade, _user$currentTrade$ob, _user$currentTrade2, _user$currentTrade2$o, _user$currentTrade3, _user$currentTrade3$o, _address$address25, _address$address26, _address$address26$ne, _address$address27, _address$address28, _address$address29, _address$address30, _address$address31, _address$address32, _address$address32$fi, _address$address32$fi2, _address$address33, _address$address33$fi, _address$address33$fi2, _address$address34, _address$address35, _address$address36, _address$address37, _address$address38, _address$address39, _address$address40, _address$address41, _address$address42, _address$address42$ci, _address$address43, _address$address43$re, _address$address44, _address$address45, _address$address45$co, _address$address46, _address$address46$re, _address$address47, _address$address47$ci, _address$address48, _address$address48$co, _address$address49;

  var location = useLocation();
  var intl = useIntl();
  var navigate = useNavigate();

  var _useAuth = useAuth(),
      createAddressAndChangeCurrentTrade = _useAuth.createAddressAndChangeCurrentTrade,
      user = _useAuth.user,
      updateAddressAndChangeCurrentTrade = _useAuth.updateAddressAndChangeCurrentTrade;

  var _React$useContext = React.useContext(ChangeAmountProductsContext),
      maxProductsPerCategory = _React$useContext.maxProductsPerCategory;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      disable = _React$useState2[0],
      setDisable = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      submit = _React$useState4[0],
      setSubmit = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loadingUserName = _React$useState6[0],
      setLoadingUserName = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      showUserName = _React$useState8[0],
      setShowUserName = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      showAlertNeigDoesNotMatchOrWithoutCoverage = _React$useState10[0],
      setShowAlertNeigDoesNotMatchOrWithoutCoverage = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      showAlertNeighborhoodWithoutCoverage = _React$useState12[0],
      setShowAlertNeighborhoodWithoutCoverage = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      showIdentityCard = _React$useState14[0],
      setShowIdentityCard = _React$useState14[1];

  var _React$useState15 = React.useState(false),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      showIdentityCardType = _React$useState16[0],
      setShowIdentityCardType = _React$useState16[1];

  var _React$useState17 = React.useState(false),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      showUserEmail = _React$useState18[0],
      setShowUserEmail = _React$useState18[1];

  var _React$useState19 = React.useState(),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      errorName = _React$useState20[0],
      setErrorName = _React$useState20[1];

  var _React$useState21 = React.useState(""),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      submitBtnText = _React$useState22[0],
      setSubmitBtnText = _React$useState22[1];

  var _React$useState23 = React.useState(""),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      title = _React$useState24[0],
      setTitle = _React$useState24[1];

  var _React$useState25 = React.useState(),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      address = _React$useState26[0],
      setAddress = _React$useState26[1];

  var _React$useState27 = React.useState([]),
      _React$useState28 = _slicedToArray(_React$useState27, 2),
      nameOptions = _React$useState28[0],
      setNameOptions = _React$useState28[1];

  var _React$useState29 = React.useState([]),
      _React$useState30 = _slicedToArray(_React$useState29, 2),
      neighborhoodsAttention = _React$useState30[0],
      setNeighborhoodsAttention = _React$useState30[1];

  var _React$useState31 = React.useState([]),
      _React$useState32 = _slicedToArray(_React$useState31, 2),
      errors = _React$useState32[0],
      setErrors = _React$useState32[1];

  var _React$useState33 = React.useState({
    neighborhoodDoesNotMatch: false,
    neighborhoodId: "",
    neighborhoodName: "",
    neighborhoodTradeId: ""
  }),
      _React$useState34 = _slicedToArray(_React$useState33, 2),
      realNeighborhood = _React$useState34[0],
      setRealNeighborhood = _React$useState34[1];

  var obligatoryFieldIdentityCard = user === null || user === void 0 ? void 0 : (_user$currentTrade = user.currentTrade) === null || _user$currentTrade === void 0 ? void 0 : (_user$currentTrade$ob = _user$currentTrade.obligatoryField) === null || _user$currentTrade$ob === void 0 ? void 0 : _user$currentTrade$ob.filter(function (obligatoryField) {
    var _obligatoryField$mode;

    return (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName) && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName) !== "" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName.toLowerCase()) === "identity_card" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.role.toLowerCase()) === "customer" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : (_obligatoryField$mode = obligatoryField.modelName) === null || _obligatoryField$mode === void 0 ? void 0 : _obligatoryField$mode.toLowerCase()) === "user";
  });
  var obligatoryFieldIdentityCardType = user === null || user === void 0 ? void 0 : (_user$currentTrade2 = user.currentTrade) === null || _user$currentTrade2 === void 0 ? void 0 : (_user$currentTrade2$o = _user$currentTrade2.obligatoryField) === null || _user$currentTrade2$o === void 0 ? void 0 : _user$currentTrade2$o.filter(function (obligatoryField) {
    var _obligatoryField$mode2;

    return (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName) && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName) !== "" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName.toLowerCase()) === "identity_card_type" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.role.toLowerCase()) === "customer" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : (_obligatoryField$mode2 = obligatoryField.modelName) === null || _obligatoryField$mode2 === void 0 ? void 0 : _obligatoryField$mode2.toLowerCase()) === "user";
  });
  var obligatoryFieldEmail = user === null || user === void 0 ? void 0 : (_user$currentTrade3 = user.currentTrade) === null || _user$currentTrade3 === void 0 ? void 0 : (_user$currentTrade3$o = _user$currentTrade3.obligatoryField) === null || _user$currentTrade3$o === void 0 ? void 0 : _user$currentTrade3$o.filter(function (obligatoryField) {
    var _obligatoryField$mode3;

    return (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName) && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName) !== "" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.fieldName.toLowerCase()) === "email" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : obligatoryField.role.toLowerCase()) === "customer" && (obligatoryField === null || obligatoryField === void 0 ? void 0 : (_obligatoryField$mode3 = obligatoryField.modelName) === null || _obligatoryField$mode3 === void 0 ? void 0 : _obligatoryField$mode3.toLowerCase()) === "user";
  });

  var _useCreateUserAddress = useCreateUserAddress(),
      _useCreateUserAddress2 = _slicedToArray(_useCreateUserAddress, 2),
      setCreateUserAddress = _useCreateUserAddress2[0],
      _useCreateUserAddress3 = _useCreateUserAddress2[1],
      createData = _useCreateUserAddress3.data,
      addressCreateErrors = _useCreateUserAddress3.error,
      addressCreateLoading = _useCreateUserAddress3.loading;

  var _useUpdateUserAddress = useUpdateUserAddress(),
      _useUpdateUserAddress2 = _slicedToArray(_useUpdateUserAddress, 2),
      setUpdateUserAddress = _useUpdateUserAddress2[0],
      _useUpdateUserAddress3 = _useUpdateUserAddress2[1],
      updateData = _useUpdateUserAddress3.data,
      addressUpdateErrors = _useUpdateUserAddress3.error,
      addressUpdateLoading = _useUpdateUserAddress3.loading;

  var _handleChangeCurrentTrade = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address) {
      var _address$address, _address$address2, _address$address3, _address$address4, _address$address5, _address$address5$fir, _address$address5$fir2, _address$address6, _address$address6$fir, _address$address6$fir2, _address$address7, _address$address8, _address$address9, _address$address10, _address$address11, _address$address12, _address$address13, _address$address14, _address$address15, _address$address15$ci, _address$address16, _address$address16$re, _address$address17, _address$address18, _address$address18$co, _address$address19, _address$address19$re, _address$address20, _address$address20$ci, _address$address21, _address$address21$co, _address$address22;

      var inputAddress, _user$currentTrade4, _user$currentTrade5, _user$currentTrade6, _user$currentTrade7, _dataError$error, _yield$createAddressA, dataError, _user$currentTrade8, _user$currentTrade9, _user$currentTrade10, _user$currentTrade11, _dataError$error2, _yield$updateAddressA, _dataError, whereFrom;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              inputAddress = {
                firstName: (address === null || address === void 0 ? void 0 : (_address$address = address.address) === null || _address$address === void 0 ? void 0 : _address$address.firstNameSelect) === undefined ? (address === null || address === void 0 ? void 0 : (_address$address2 = address.address) === null || _address$address2 === void 0 ? void 0 : _address$address2.firstNameWrite) === "" || (address === null || address === void 0 ? void 0 : (_address$address3 = address.address) === null || _address$address3 === void 0 ? void 0 : _address$address3.firstNameSelect) === undefined ? intl.formatMessage(checkoutMessages.myHome) : address === null || address === void 0 ? void 0 : (_address$address4 = address.address) === null || _address$address4 === void 0 ? void 0 : _address$address4.firstNameWrite : (address === null || address === void 0 ? void 0 : (_address$address5 = address.address) === null || _address$address5 === void 0 ? void 0 : (_address$address5$fir = _address$address5.firstNameSelect) === null || _address$address5$fir === void 0 ? void 0 : (_address$address5$fir2 = _address$address5$fir.id) === null || _address$address5$fir2 === void 0 ? void 0 : _address$address5$fir2.toUpperCase()) !== intl.formatMessage(checkoutMessages.other).toUpperCase() && (address === null || address === void 0 ? void 0 : (_address$address6 = address.address) === null || _address$address6 === void 0 ? void 0 : (_address$address6$fir = _address$address6.firstNameSelect) === null || _address$address6$fir === void 0 ? void 0 : (_address$address6$fir2 = _address$address6$fir.id) === null || _address$address6$fir2 === void 0 ? void 0 : _address$address6$fir2.toUpperCase()) !== intl.formatMessage(checkoutMessages.other).toUpperCase() ? address === null || address === void 0 ? void 0 : (_address$address7 = address.address) === null || _address$address7 === void 0 ? void 0 : _address$address7.firstNameSelect.id : address === null || address === void 0 ? void 0 : (_address$address8 = address.address) === null || _address$address8 === void 0 ? void 0 : _address$address8.firstNameWrite,
                lastName: address === null || address === void 0 ? void 0 : (_address$address9 = address.address) === null || _address$address9 === void 0 ? void 0 : _address$address9.lastName,
                latitude: address === null || address === void 0 ? void 0 : (_address$address10 = address.address) === null || _address$address10 === void 0 ? void 0 : _address$address10.latitude,
                longitude: address === null || address === void 0 ? void 0 : (_address$address11 = address.address) === null || _address$address11 === void 0 ? void 0 : _address$address11.longitude,
                companyName: address === null || address === void 0 ? void 0 : (_address$address12 = address.address) === null || _address$address12 === void 0 ? void 0 : _address$address12.companyName,
                streetAddress1: address === null || address === void 0 ? void 0 : (_address$address13 = address.address) === null || _address$address13 === void 0 ? void 0 : _address$address13.streetAddress1,
                streetAddress2: address === null || address === void 0 ? void 0 : (_address$address14 = address.address) === null || _address$address14 === void 0 ? void 0 : _address$address14.streetAddress2,
                city: address === null || address === void 0 ? void 0 : (_address$address15 = address.address) === null || _address$address15 === void 0 ? void 0 : (_address$address15$ci = _address$address15.city2) === null || _address$address15$ci === void 0 ? void 0 : _address$address15$ci.name,
                countryArea: (address === null || address === void 0 ? void 0 : (_address$address16 = address.address) === null || _address$address16 === void 0 ? void 0 : (_address$address16$re = _address$address16.region2) === null || _address$address16$re === void 0 ? void 0 : _address$address16$re.name) || "No definidoFront",
                phone: address === null || address === void 0 ? void 0 : (_address$address17 = address.address) === null || _address$address17 === void 0 ? void 0 : _address$address17.phone,
                country: address === null || address === void 0 ? void 0 : (_address$address18 = address.address) === null || _address$address18 === void 0 ? void 0 : (_address$address18$co = _address$address18.country) === null || _address$address18$co === void 0 ? void 0 : _address$address18$co.code,
                neighborhood: realNeighborhood === null || realNeighborhood === void 0 ? void 0 : realNeighborhood.neighborhoodId,
                region2: address === null || address === void 0 ? void 0 : (_address$address19 = address.address) === null || _address$address19 === void 0 ? void 0 : (_address$address19$re = _address$address19.region2) === null || _address$address19$re === void 0 ? void 0 : _address$address19$re.id,
                city2: address === null || address === void 0 ? void 0 : (_address$address20 = address.address) === null || _address$address20 === void 0 ? void 0 : (_address$address20$ci = _address$address20.city2) === null || _address$address20$ci === void 0 ? void 0 : _address$address20$ci.id,
                country2: address === null || address === void 0 ? void 0 : (_address$address21 = address.address) === null || _address$address21 === void 0 ? void 0 : (_address$address21$co = _address$address21.country2) === null || _address$address21$co === void 0 ? void 0 : _address$address21$co.id,
                postalCode: address === null || address === void 0 ? void 0 : (_address$address22 = address.address) === null || _address$address22 === void 0 ? void 0 : _address$address22.postalCode
              };

              if (!location.pathname.includes("/address/add")) {
                _context.next = 13;
                break;
              }

              setDisable(true);
              _context.next = 5;
              return createAddressAndChangeCurrentTrade((user === null || user === void 0 ? void 0 : (_user$currentTrade4 = user.currentTrade) === null || _user$currentTrade4 === void 0 ? void 0 : _user$currentTrade4.idMainTrade) ? isNaN(parseInt(user === null || user === void 0 ? void 0 : (_user$currentTrade5 = user.currentTrade) === null || _user$currentTrade5 === void 0 ? void 0 : _user$currentTrade5.idMainTrade, 10)) ? parseInt(window.atob("".concat(user === null || user === void 0 ? void 0 : (_user$currentTrade6 = user.currentTrade) === null || _user$currentTrade6 === void 0 ? void 0 : _user$currentTrade6.idMainTrade)).split(":")[1], 10) : parseInt(user === null || user === void 0 ? void 0 : (_user$currentTrade7 = user.currentTrade) === null || _user$currentTrade7 === void 0 ? void 0 : _user$currentTrade7.idMainTrade, 10) : 0, inputAddress, maxProductsPerCategory + 1, "NORMAL");

            case 5:
              _yield$createAddressA = _context.sent;
              dataError = _yield$createAddressA.dataError;

              if (!((dataError === null || dataError === void 0 ? void 0 : (_dataError$error = dataError.error) === null || _dataError$error === void 0 ? void 0 : _dataError$error.length) > 0)) {
                _context.next = 11;
                break;
              }

              setErrors(dataError === null || dataError === void 0 ? void 0 : dataError.error);
              setDisable(false);
              return _context.abrupt("return");

            case 11:
              _context.next = 23;
              break;

            case 13:
              if (!location.pathname.includes("/address/edit")) {
                _context.next = 23;
                break;
              }

              setDisable(true);
              _context.next = 17;
              return updateAddressAndChangeCurrentTrade(address === null || address === void 0 ? void 0 : address.id, (user === null || user === void 0 ? void 0 : (_user$currentTrade8 = user.currentTrade) === null || _user$currentTrade8 === void 0 ? void 0 : _user$currentTrade8.idMainTrade) ? isNaN(parseInt(user === null || user === void 0 ? void 0 : (_user$currentTrade9 = user.currentTrade) === null || _user$currentTrade9 === void 0 ? void 0 : _user$currentTrade9.idMainTrade, 10)) ? parseInt(window.atob("".concat(user === null || user === void 0 ? void 0 : (_user$currentTrade10 = user.currentTrade) === null || _user$currentTrade10 === void 0 ? void 0 : _user$currentTrade10.idMainTrade)).split(":")[1], 10) : parseInt(user === null || user === void 0 ? void 0 : (_user$currentTrade11 = user.currentTrade) === null || _user$currentTrade11 === void 0 ? void 0 : _user$currentTrade11.idMainTrade, 10) : 0, inputAddress, maxProductsPerCategory + 1, "NORMAL");

            case 17:
              _yield$updateAddressA = _context.sent;
              _dataError = _yield$updateAddressA.dataError;

              if (!((_dataError === null || _dataError === void 0 ? void 0 : (_dataError$error2 = _dataError.error) === null || _dataError$error2 === void 0 ? void 0 : _dataError$error2.length) > 0)) {
                _context.next = 23;
                break;
              }

              setErrors(_dataError === null || _dataError === void 0 ? void 0 : _dataError.error);
              setDisable(false);
              return _context.abrupt("return");

            case 23:
              localStorage.removeItem("home_cache");
              localStorage.removeItem("sale_cache");
              localStorage.removeItem("products_cache");
              localStorage.removeItem("category_sale_cache");
              localStorage.removeItem("category_products_cache");
              localStorage.removeItem("subcategory_products_cache");
              whereFrom = localStorage.getItem("address-from");

              if (whereFrom === "profile") {
                navigate(-1);
              } else if (whereFrom === "checkout") {
                navigate("/");
              }

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChangeCurrentTrade(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var goBackAddress = React.useCallback(function () {
    var addressUndefined = localStorage.getItem("address-undefined");

    if (addressUndefined === "true") {
      navigate("/");
    } else {
      navigate(-1);
    }
  }, []);
  useEffect(function () {
    if (addressCreateErrors) {
      var _addressCreateErrors$;

      setErrors(addressCreateErrors === null || addressCreateErrors === void 0 ? void 0 : (_addressCreateErrors$ = addressCreateErrors.extraInfo) === null || _addressCreateErrors$ === void 0 ? void 0 : _addressCreateErrors$.userInputErrors);
    }

    return function () {
      setErrors([]);
    };
  }, [addressCreateErrors]);
  useEffect(function () {
    if (addressUpdateErrors) {
      var _addressUpdateErrors$;

      setErrors(addressUpdateErrors === null || addressUpdateErrors === void 0 ? void 0 : (_addressUpdateErrors$ = addressUpdateErrors.extraInfo) === null || _addressUpdateErrors$ === void 0 ? void 0 : _addressUpdateErrors$.userInputErrors);
    }

    return function () {
      setErrors([]);
    };
  }, [addressUpdateErrors]);
  useEffect(function () {
    if (createData && !addressCreateErrors || updateData && !addressUpdateErrors) {
      setSubmit(true); // hideModal();
    }

    return function () {};
  }, [createData, updateData, addressCreateErrors, addressUpdateErrors]);
  useEffect(function () {
    if (errors && (errors === null || errors === void 0 ? void 0 : errors.length) > 0) {
      setSubmit(false);
      setDisable(false);
    } // return () => {
    //   setSubmit(false);
    //   setDisable(false);
    // };


    return function () {};
  }, [errors]);
  useEffect(function () {
    var whereFrom = localStorage.getItem("address-from");

    if (!addressCreateLoading && !addressUpdateLoading && !addressCreateErrors && !addressUpdateErrors && !loadingUserName && !(errorName === null || errorName === void 0 ? void 0 : errorName.userName) && !(errorName === null || errorName === void 0 ? void 0 : errorName.userAddress) && !(errorName === null || errorName === void 0 ? void 0 : errorName.identityCard) && submit) {
      if (whereFrom === "profile") {
        navigate(-1);
      } else if (whereFrom === "checkout") {
        var _address$address23, _address$address24, _address$address24$st;

        if ((address === null || address === void 0 ? void 0 : (_address$address23 = address.address) === null || _address$address23 === void 0 ? void 0 : _address$address23.streetAddress1) !== "" && (address === null || address === void 0 ? void 0 : (_address$address24 = address.address) === null || _address$address24 === void 0 ? void 0 : (_address$address24$st = _address$address24.streetAddress1) === null || _address$address24$st === void 0 ? void 0 : _address$address24$st.toLowerCase()) !== "no definida") {
          localStorage.setItem("address-id", (address === null || address === void 0 ? void 0 : address.id) || "");
        } else {
          localStorage.setItem("address-id", "");
        }

        localStorage.setItem("address-data", JSON.stringify((address === null || address === void 0 ? void 0 : address.address) || ""));
        navigate("/checkout/address");
      }
    }

    return function () {};
  }, [addressCreateLoading, addressUpdateLoading, addressCreateErrors, addressUpdateErrors, errorName, loadingUserName, submit]);
  useEffect(function () {
    if (!addressCreateLoading && !addressUpdateLoading) {
      setDisable(false);
    }

    return function () {
      setDisable(false);
    };
  }, [addressCreateLoading, addressUpdateLoading]);
  useEffect(function () {
    var whereFrom = localStorage.getItem("address-from");

    if (whereFrom === "checkout") {
      if (!(user === null || user === void 0 ? void 0 : user.hasConfirmedName)) {
        setShowUserName(true);
      }

      if ((!(user === null || user === void 0 ? void 0 : user.identityCard) || (user === null || user === void 0 ? void 0 : user.identityCard) === "" || (user === null || user === void 0 ? void 0 : user.identityCard) === "null" || (user === null || user === void 0 ? void 0 : user.identityCard) === undefined) && obligatoryFieldIdentityCard && obligatoryFieldIdentityCard.length > 0) {
        setShowIdentityCard(true);
      }

      if ((!(user === null || user === void 0 ? void 0 : user.identityCardType) || (user === null || user === void 0 ? void 0 : user.identityCardType) === "" || (user === null || user === void 0 ? void 0 : user.identityCardType) === "null" || (user === null || user === void 0 ? void 0 : user.identityCardType) === undefined) && obligatoryFieldIdentityCardType && obligatoryFieldIdentityCardType.length > 0) {
        setShowIdentityCardType(true);
      }

      if ((!(user === null || user === void 0 ? void 0 : user.userEmail) || (user === null || user === void 0 ? void 0 : user.userEmail) === "" || (user === null || user === void 0 ? void 0 : user.userEmail) === "null" || (user === null || user === void 0 ? void 0 : user.userEmail) === undefined) && obligatoryFieldEmail && obligatoryFieldEmail.length > 0) {
        setShowUserEmail(true);
      }
    } // if (location.pathname.includes("/add")) {


    if (location.pathname.includes("/address/add")) {
      setSubmitBtnText(intl.formatMessage(commonMessages.add));
      setTitle(intl.formatMessage(checkoutMessages.addNewAddress));
    } // if (location.pathname.includes("/edit")) {


    if (location.pathname.includes("/address/edit")) {
      if (whereFrom === "checkout") {
        if (!(user === null || user === void 0 ? void 0 : user.hasConfirmedName)) {
          setShowUserName(true);
        }

        if ((!(user === null || user === void 0 ? void 0 : user.identityCard) || (user === null || user === void 0 ? void 0 : user.identityCard) === "" || (user === null || user === void 0 ? void 0 : user.identityCard) === "null" || (user === null || user === void 0 ? void 0 : user.identityCard) === undefined) && obligatoryFieldIdentityCard && obligatoryFieldIdentityCard.length > 0) {
          setShowIdentityCard(true);
        }

        if ((!(user === null || user === void 0 ? void 0 : user.identityCardType) || (user === null || user === void 0 ? void 0 : user.identityCardType) === "" || (user === null || user === void 0 ? void 0 : user.identityCardType) === "null" || (user === null || user === void 0 ? void 0 : user.identityCardType) === undefined) && obligatoryFieldIdentityCardType && obligatoryFieldIdentityCardType.length > 0) {
          setShowIdentityCardType(true);
        }

        if ((!(user === null || user === void 0 ? void 0 : user.email) || (user === null || user === void 0 ? void 0 : user.email) === "" || (user === null || user === void 0 ? void 0 : user.email) === "null" || (user === null || user === void 0 ? void 0 : user.email) === undefined) && obligatoryFieldEmail && obligatoryFieldEmail.length > 0) {
          setShowUserEmail(true);
        }

        setSubmitBtnText(intl.formatMessage(commonMessages.continue));
        setTitle(intl.formatMessage(checkoutMessages.completeShippingAddress));
      } else {
        setSubmitBtnText(intl.formatMessage(commonMessages.save));
        setTitle(intl.formatMessage(commonMessages.editAddress));
      }

      localStorage.setItem("address-user-id", "");
    }

    var addressData = localStorage.getItem("address-data");

    if (addressData !== null && addressData !== "undefined" && addressData !== "") {
      setAddress(JSON.parse(addressData));
    } else {
      setAddress(undefined);
    }

    var addressNameOptions = localStorage.getItem("address-name-options");

    if (addressNameOptions && addressNameOptions !== null && addressNameOptions !== "" && addressNameOptions !== "undefined") {
      setNameOptions(JSON.parse(addressNameOptions));
    } else {
      setNameOptions([]);
    }

    var addressNeighborhood = localStorage.getItem("address-neighborhood");

    if (addressNeighborhood && addressNeighborhood !== null && addressNeighborhood !== "" && addressNeighborhood !== "undefined") {
      setNeighborhoodsAttention(JSON.parse(addressNeighborhood));
    } else {
      setNeighborhoodsAttention([]);
    }

    return function () {};
  }, []);
  useEffect(function () {
    if (errors && (errors === null || errors === void 0 ? void 0 : errors.length) > 0) {
      errors.map(function (error) {
        if ((error === null || error === void 0 ? void 0 : error.code) === "INVALID_SHIPPING_METHOD" || (error === null || error === void 0 ? void 0 : error.code) === "INVALID_ADDRESS") {
          setRealNeighborhood({
            neighborhoodTradeId: error === null || error === void 0 ? void 0 : error.tradeId,
            neighborhoodDoesNotMatch: (error === null || error === void 0 ? void 0 : error.code) === "INVALID_ADDRESS",
            neighborhoodId: error === null || error === void 0 ? void 0 : error.neighborhoodId,
            neighborhoodName: error === null || error === void 0 ? void 0 : error.neighborhoodName
          });

          if (showAlertNeighborhoodWithoutCoverage) {
            setShowAlertNeighborhoodWithoutCoverage(false);
          }

          if (!showAlertNeigDoesNotMatchOrWithoutCoverage) {
            setShowAlertNeigDoesNotMatchOrWithoutCoverage(true);
          }
        }
      });
    }
  }, [errors]);
  return React.createElement(React.Fragment, null, React.createElement(MainMenu, {
    gobackAddress: true,
    search: false,
    cart: false
  }), React.createElement(Media, {
    query: {
      minWidth: xMediumScreen
    }
  }, function (matches) {
    return matches && React.createElement(S.GoBack, {
      onClick: goBackAddress
    }, React.createElement(S.GoBackImg, null, React.createElement(ReactSVG, {
      path: goBackImg
    })), React.createElement(S.GoBackLetter, null, React.createElement(FormattedMessage, {
      id: "@next.pages.AddressFormPage.AddressFormPage.1347475195",
      defaultMessage: "Back"
    })));
  }), React.createElement(S.Body, null, title && React.createElement(S.Title, null, title), React.createElement(AddressForm, {
    nameOptions: nameOptions,
    neighborhoodsAttention: neighborhoodsAttention,
    setErrorsQuery: function setErrorsQuery(newError) {
      return setErrors(newError);
    },
    errorsQuery: errors,
    formId: formId,
    address: address || undefined,
    showUserName: showUserName,
    showIdentityCard: showIdentityCard,
    showIdentityCardType: showIdentityCardType,
    showUserEmail: showUserEmail,
    userIdentityCard: (user === null || user === void 0 ? void 0 : user.identityCard) && (user === null || user === void 0 ? void 0 : user.identityCard) !== "null" ? user === null || user === void 0 ? void 0 : user.identityCard : "",
    userIdentityCardType: (user === null || user === void 0 ? void 0 : user.identityCardType) && (user === null || user === void 0 ? void 0 : user.identityCardType) !== "null" ? user === null || user === void 0 ? void 0 : user.identityCardType : "",
    userEmail: (user === null || user === void 0 ? void 0 : user.userEmail) && (user === null || user === void 0 ? void 0 : user.userEmail) !== "null" ? user === null || user === void 0 ? void 0 : user.userEmail : "",
    obligatoryFieldIdentityCard: obligatoryFieldIdentityCard,
    obligatoryFieldIdentityCardType: obligatoryFieldIdentityCardType,
    obligatoryFieldUserEmail: obligatoryFieldEmail,
    userLastName: user === null || user === void 0 ? void 0 : user.lastName,
    handleErrorName: function handleErrorName(value) {
      setErrorName(value);
    },
    handleLoadingUserName: setLoadingUserName,
    handleSubmit: function handleSubmit(data) {
      var _data$firstNameSelect, _data$firstNameSelect2, _data$firstNameSelect3, _data$firstNameSelect4, _data$city, _data$region, _data$country, _data$neighborhood, _data$region2, _data$region3, _data$region4, _data$region5, _data$city2, _data$city3, _data$city4, _data$city5, _data$country2, _data$country3, _data$country4, _data$country5;

      setDisable(true);
      setAddress({
        address: data,
        id: address === null || address === void 0 ? void 0 : address.id
      });
      var input = {
        firstName: (data === null || data === void 0 ? void 0 : data.firstNameSelect) === undefined ? (data === null || data === void 0 ? void 0 : data.firstNameWrite) === "" || (data === null || data === void 0 ? void 0 : data.firstNameSelect) === undefined ? intl.formatMessage(checkoutMessages.myHome) : data === null || data === void 0 ? void 0 : data.firstNameWrite : (data === null || data === void 0 ? void 0 : (_data$firstNameSelect = data.firstNameSelect) === null || _data$firstNameSelect === void 0 ? void 0 : (_data$firstNameSelect2 = _data$firstNameSelect.id) === null || _data$firstNameSelect2 === void 0 ? void 0 : _data$firstNameSelect2.toUpperCase()) !== intl.formatMessage(checkoutMessages.other).toUpperCase() && (data === null || data === void 0 ? void 0 : (_data$firstNameSelect3 = data.firstNameSelect) === null || _data$firstNameSelect3 === void 0 ? void 0 : (_data$firstNameSelect4 = _data$firstNameSelect3.id) === null || _data$firstNameSelect4 === void 0 ? void 0 : _data$firstNameSelect4.toUpperCase()) !== intl.formatMessage(checkoutMessages.other).toUpperCase() ? data === null || data === void 0 ? void 0 : data.firstNameSelect.id : data === null || data === void 0 ? void 0 : data.firstNameWrite,
        lastName: data === null || data === void 0 ? void 0 : data.lastName,
        latitude: data === null || data === void 0 ? void 0 : data.latitude,
        longitude: data === null || data === void 0 ? void 0 : data.longitude,
        companyName: data === null || data === void 0 ? void 0 : data.companyName,
        streetAddress1: data === null || data === void 0 ? void 0 : data.streetAddress1,
        streetAddress2: data === null || data === void 0 ? void 0 : data.streetAddress2,
        city: data === null || data === void 0 ? void 0 : (_data$city = data.city2) === null || _data$city === void 0 ? void 0 : _data$city.name,
        countryArea: (data === null || data === void 0 ? void 0 : (_data$region = data.region2) === null || _data$region === void 0 ? void 0 : _data$region.name) || "No definidoFront",
        phone: data === null || data === void 0 ? void 0 : data.phone,
        country: data === null || data === void 0 ? void 0 : (_data$country = data.country) === null || _data$country === void 0 ? void 0 : _data$country.code,
        neighborhood: data === null || data === void 0 ? void 0 : (_data$neighborhood = data.neighborhood) === null || _data$neighborhood === void 0 ? void 0 : _data$neighborhood.id,
        region2: (data === null || data === void 0 ? void 0 : (_data$region2 = data.region2) === null || _data$region2 === void 0 ? void 0 : _data$region2.id) && isNaN(parseInt(data === null || data === void 0 ? void 0 : (_data$region3 = data.region2) === null || _data$region3 === void 0 ? void 0 : _data$region3.id, 10)) ? data === null || data === void 0 ? void 0 : (_data$region4 = data.region2) === null || _data$region4 === void 0 ? void 0 : _data$region4.id : window.btoa("Region:".concat(data === null || data === void 0 ? void 0 : (_data$region5 = data.region2) === null || _data$region5 === void 0 ? void 0 : _data$region5.id)),
        city2: (data === null || data === void 0 ? void 0 : (_data$city2 = data.city2) === null || _data$city2 === void 0 ? void 0 : _data$city2.id) && isNaN(parseInt(data === null || data === void 0 ? void 0 : (_data$city3 = data.city2) === null || _data$city3 === void 0 ? void 0 : _data$city3.id, 10)) ? data === null || data === void 0 ? void 0 : (_data$city4 = data.city2) === null || _data$city4 === void 0 ? void 0 : _data$city4.id : window.btoa("City:".concat(data === null || data === void 0 ? void 0 : (_data$city5 = data.city2) === null || _data$city5 === void 0 ? void 0 : _data$city5.id)),
        country2: (data === null || data === void 0 ? void 0 : (_data$country2 = data.country2) === null || _data$country2 === void 0 ? void 0 : _data$country2.id) && isNaN(parseInt(data === null || data === void 0 ? void 0 : (_data$country3 = data.country2) === null || _data$country3 === void 0 ? void 0 : _data$country3.id, 10)) ? data === null || data === void 0 ? void 0 : (_data$country4 = data.country2) === null || _data$country4 === void 0 ? void 0 : _data$country4.id : window.btoa("Country:".concat(data === null || data === void 0 ? void 0 : (_data$country5 = data.country2) === null || _data$country5 === void 0 ? void 0 : _data$country5.id)),
        postalCode: data === null || data === void 0 ? void 0 : data.postalCode
      };

      if (!submit) {
        if (!(address === null || address === void 0 ? void 0 : address.id)) {
          setCreateUserAddress({
            input: input
          });
          setSubmit(true);
        } else if (address === null || address === void 0 ? void 0 : address.id) {
          setUpdateUserAddress({
            id: address === null || address === void 0 ? void 0 : address.id,
            input: input
          });
          setSubmit(true);
        }
      }
    }
  })), React.createElement(S.Footer, null, disable || loadingUserName || addressCreateLoading || addressUpdateLoading ? React.createElement(Loader, null) : React.createElement(FormFooter, _extends({
    divider: true,
    disabled: disable
  }, getSubmitBtnProps(submitBtnText, submitButtonTestingContext), {
    formId: formId
  }))), showAlertNeighborhoodWithoutCoverage && React.createElement(AlertNeighborhoodOtherTrade, {
    loading: submit,
    hideModal: function hideModal() {
      setShowAlertNeighborhoodWithoutCoverage(false);
    },
    realNeighborhoodName: realNeighborhood === null || realNeighborhood === void 0 ? void 0 : realNeighborhood.neighborhoodName,
    handleChangeCurrentTrade: function handleChangeCurrentTrade() {
      if (address) {
        _handleChangeCurrentTrade(address);
      }
    },
    setSubmit: setSubmit
  }), showAlertNeigDoesNotMatchOrWithoutCoverage && React.createElement(AlertNeigDoesNotMatchOrWithoutCoverage, {
    idAddress: address === null || address === void 0 ? void 0 : address.id,
    hideModal: function hideModal() {
      setErrors([]);
      setShowAlertNeigDoesNotMatchOrWithoutCoverage(false);
    },
    currentNeighborhoodName: (address === null || address === void 0 ? void 0 : (_address$address25 = address.address) === null || _address$address25 === void 0 ? void 0 : _address$address25.neighborhoodSelect) === undefined ? address === null || address === void 0 ? void 0 : (_address$address26 = address.address) === null || _address$address26 === void 0 ? void 0 : (_address$address26$ne = _address$address26.neighborhood) === null || _address$address26$ne === void 0 ? void 0 : _address$address26$ne.name : address === null || address === void 0 ? void 0 : (_address$address27 = address.address) === null || _address$address27 === void 0 ? void 0 : _address$address27.neighborhoodSelect.name,
    loading: addressCreateLoading || addressUpdateLoading,
    realNeighborhoodTradeId: realNeighborhood === null || realNeighborhood === void 0 ? void 0 : realNeighborhood.neighborhoodTradeId,
    realNeighborhoodName: realNeighborhood === null || realNeighborhood === void 0 ? void 0 : realNeighborhood.neighborhoodName,
    neighborhoodDoesNotMatch: realNeighborhood === null || realNeighborhood === void 0 ? void 0 : realNeighborhood.neighborhoodDoesNotMatch,
    newAddress: {
      firstName: (address === null || address === void 0 ? void 0 : (_address$address28 = address.address) === null || _address$address28 === void 0 ? void 0 : _address$address28.firstNameSelect) === undefined ? (address === null || address === void 0 ? void 0 : (_address$address29 = address.address) === null || _address$address29 === void 0 ? void 0 : _address$address29.firstNameWrite) === "" || (address === null || address === void 0 ? void 0 : (_address$address30 = address.address) === null || _address$address30 === void 0 ? void 0 : _address$address30.firstNameSelect) === undefined ? intl.formatMessage(checkoutMessages.myHome) : address === null || address === void 0 ? void 0 : (_address$address31 = address.address) === null || _address$address31 === void 0 ? void 0 : _address$address31.firstNameWrite : (address === null || address === void 0 ? void 0 : (_address$address32 = address.address) === null || _address$address32 === void 0 ? void 0 : (_address$address32$fi = _address$address32.firstNameSelect) === null || _address$address32$fi === void 0 ? void 0 : (_address$address32$fi2 = _address$address32$fi.id) === null || _address$address32$fi2 === void 0 ? void 0 : _address$address32$fi2.toUpperCase()) !== intl.formatMessage(checkoutMessages.other).toUpperCase() && (address === null || address === void 0 ? void 0 : (_address$address33 = address.address) === null || _address$address33 === void 0 ? void 0 : (_address$address33$fi = _address$address33.firstNameSelect) === null || _address$address33$fi === void 0 ? void 0 : (_address$address33$fi2 = _address$address33$fi.id) === null || _address$address33$fi2 === void 0 ? void 0 : _address$address33$fi2.toUpperCase()) !== intl.formatMessage(checkoutMessages.other).toUpperCase() ? address === null || address === void 0 ? void 0 : (_address$address34 = address.address) === null || _address$address34 === void 0 ? void 0 : _address$address34.firstNameSelect.id : address === null || address === void 0 ? void 0 : (_address$address35 = address.address) === null || _address$address35 === void 0 ? void 0 : _address$address35.firstNameWrite,
      lastName: address === null || address === void 0 ? void 0 : (_address$address36 = address.address) === null || _address$address36 === void 0 ? void 0 : _address$address36.lastName,
      latitude: address === null || address === void 0 ? void 0 : (_address$address37 = address.address) === null || _address$address37 === void 0 ? void 0 : _address$address37.latitude,
      longitude: address === null || address === void 0 ? void 0 : (_address$address38 = address.address) === null || _address$address38 === void 0 ? void 0 : _address$address38.longitude,
      companyName: address === null || address === void 0 ? void 0 : (_address$address39 = address.address) === null || _address$address39 === void 0 ? void 0 : _address$address39.companyName,
      streetAddress1: address === null || address === void 0 ? void 0 : (_address$address40 = address.address) === null || _address$address40 === void 0 ? void 0 : _address$address40.streetAddress1,
      streetAddress2: address === null || address === void 0 ? void 0 : (_address$address41 = address.address) === null || _address$address41 === void 0 ? void 0 : _address$address41.streetAddress2,
      city: address === null || address === void 0 ? void 0 : (_address$address42 = address.address) === null || _address$address42 === void 0 ? void 0 : (_address$address42$ci = _address$address42.city2) === null || _address$address42$ci === void 0 ? void 0 : _address$address42$ci.name,
      countryArea: (address === null || address === void 0 ? void 0 : (_address$address43 = address.address) === null || _address$address43 === void 0 ? void 0 : (_address$address43$re = _address$address43.region2) === null || _address$address43$re === void 0 ? void 0 : _address$address43$re.name) || "No definidoFront",
      phone: address === null || address === void 0 ? void 0 : (_address$address44 = address.address) === null || _address$address44 === void 0 ? void 0 : _address$address44.phone,
      country: address === null || address === void 0 ? void 0 : (_address$address45 = address.address) === null || _address$address45 === void 0 ? void 0 : (_address$address45$co = _address$address45.country) === null || _address$address45$co === void 0 ? void 0 : _address$address45$co.code,
      neighborhood: realNeighborhood === null || realNeighborhood === void 0 ? void 0 : realNeighborhood.neighborhoodId,
      region2: address === null || address === void 0 ? void 0 : (_address$address46 = address.address) === null || _address$address46 === void 0 ? void 0 : (_address$address46$re = _address$address46.region2) === null || _address$address46$re === void 0 ? void 0 : _address$address46$re.id,
      city2: address === null || address === void 0 ? void 0 : (_address$address47 = address.address) === null || _address$address47 === void 0 ? void 0 : (_address$address47$ci = _address$address47.city2) === null || _address$address47$ci === void 0 ? void 0 : _address$address47$ci.id,
      country2: address === null || address === void 0 ? void 0 : (_address$address48 = address.address) === null || _address$address48 === void 0 ? void 0 : (_address$address48$co = _address$address48.country2) === null || _address$address48$co === void 0 ? void 0 : _address$address48$co.id,
      postalCode: address === null || address === void 0 ? void 0 : (_address$address49 = address.address) === null || _address$address49 === void 0 ? void 0 : _address$address49.postalCode
    },
    setCreateUserAddress: setCreateUserAddress,
    setShowAlertNeighborhoodWithoutCoverage: setShowAlertNeighborhoodWithoutCoverage,
    setUpdateUserAddress: setUpdateUserAddress
  }));
};